import React, { useEffect, useState, useRef } from "react"
import get from "lodash/get"
import { API_URL, updateBettingLimitCall } from "helpers/repository"
import { getAllRiskManagementSetting } from "store/riskManagement/actions"
import axios from "axios"
import { useSelector, useDispatch } from "react-redux"

import {
  Button,
  Card,
  CardBody,
  Col,
  Form,
  Label,
  Input,
  CardTitle,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap"
import {
  getTokenFromLocalStorage,
  hasPermission,
  showErrorMessages,
} from "helpers/helpers"
import { showMessage } from "components/Common/Toaster"
import { set } from "store"

export default function Betting(props) {
  const dispatch = useDispatch()

  const [minimum_bet, setMinimumBet] = useState("")
  const [maximum_bet, setMaximumBet] = useState("")
  const [minimum_withdrawal, setMinimumWithdrawl] = useState("")
  const [auto_released_limit, setAutoReleasedLimit] = useState("")
  const [maximum_withdrawal_per_day, setMaximumWithdrawlPerDay] = useState("")
  const [maximum_payout, setMaximumPayout] = useState("")
  const [maximum_bonus_payout, setMaximumBonusPayout] = useState("")
  const [signup_freebet_amount, setSignupFreebetAmount] = useState("")
  const [minimum_odds, setMinimumOdds] = useState(0)
  const [minimum_matches, setMinimumMatches] = useState(1)
  const [freebet_minimum_odds, set_freebet_minimum_odds] = useState(0)
  const [freebet_maximum_odds, set_freebet_maximum_odds] = useState(1)
  const [freebet_minimum_matches, set_freebet_minimum_matches] = useState(1)
  const [is_bonus_active, setIsBonusActive] = useState(1)
  const [is_raf_active, setIsRafActive] = useState(1)
  const [firstDepositOdds, setfirstDepositOdds] = useState(0)
  const [firstDepositBonus, setfirstDepositBonus] = useState(0)
  const [signupValidity, setSignupValidity] = useState(0)
  const [signupRollover, setSignupRollover] = useState(0)

  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    setMinimumBet(get(props, "data.minimum_bet", ""))
    setMaximumBet(get(props, "data.maximum_bet", ""))
    setMinimumWithdrawl(get(props, "data.minimum_withdrawal", ""))
    setMaximumWithdrawlPerDay(get(props, "data.maximum_withdrawal_per_day", ""))
    setMaximumPayout(get(props, "data.maximum_payout", ""))
    setMaximumBonusPayout(get(props, "data.maximum_bonus_payout", ""))
    setMinimumOdds(get(props, "data.minimum_odds", ""))
    setMinimumMatches(get(props, "data.minimum_matches", ""))
    set_freebet_minimum_odds(get(props, "data.free_bet_minimum_odds", ""))
    set_freebet_maximum_odds(get(props, "data.free_bet_maximum_odds", ""))
    set_freebet_minimum_matches(get(props, "data.free_bet_minimum_matches", ""))
    setIsBonusActive(get(props, "data.is_bonus_active", ""))
    setIsRafActive(get(props, "data.is_raf_active", ""))
    setAutoReleasedLimit(get(props, "data.auto_released_limit", ""))
    setSignupFreebetAmount(get(props, "data.signup_freebet_amount", ""))
    setfirstDepositOdds(get(props, "data.1st_dep_odd", ""))
    setfirstDepositBonus(get(props, "data.1st_dep_bonus", ""))
    setSignupValidity(get(props, "data.signup_freebet_bonus_age", ""))
    setSignupRollover(get(props, "data.signup_freebet_rollover_limit", ""))

  }, [])

  const toggle = () => {
    setIsOpen(!isOpen)
  }

  const handleClick = () => {
    toggle()
  }

  const handleSubmit = e => {
    e.preventDefault()
    var bodyFormData = new FormData()

    bodyFormData.append("minimum_bet", minimum_bet)
    bodyFormData.append("maximum_bet", maximum_bet)
    bodyFormData.append("minimum_withdrawal", minimum_withdrawal)
    bodyFormData.append(
      "maximum_withdrawal_per_day",
      maximum_withdrawal_per_day
    )
    bodyFormData.append("auto_released_limit", auto_released_limit)
    bodyFormData.append("maximum_payout", maximum_payout)
    bodyFormData.append("maximum_bonus_payout", maximum_bonus_payout)
    bodyFormData.append("signup_freebet_amount", signup_freebet_amount)
    bodyFormData.append("minimum_odds", minimum_odds)
    bodyFormData.append("minimum_matches", minimum_matches)
    bodyFormData.append("free_bet_minimum_odds", freebet_minimum_odds)
    bodyFormData.append("free_bet_maximum_odds", freebet_maximum_odds)
    bodyFormData.append("free_bet_minimum_matches", freebet_minimum_matches)
    bodyFormData.append("is_bonus_active", is_bonus_active)
    bodyFormData.append("is_raf_active", is_raf_active)
    bodyFormData.append("1st_dep_odd", firstDepositOdds)
    bodyFormData.append("1st_dep_bonus", firstDepositBonus)
    bodyFormData.append("signup_freebet_bonus_age", signupValidity)
    bodyFormData.append("signup_freebet_rollover_limit", signupRollover)

    updateBettingLimitCall(bodyFormData)
      .then(function (response) {
        //handle success
        showMessage("success", response.data.message)
        dispatch(getAllRiskManagementSetting())
      })
      .catch(function (response) {
        //handle error
        showErrorMessages(response)
      })

    toggle()
  }

  return (
    <React.Fragment>
      <Col>
        <Card>
          <CardBody>
            <CardTitle className="mb-4">Betting</CardTitle>

            <Form>
              <div className="row mb-4">
                <Col xs={6} sm={4} md={4} lg={6}>
                  <Label className="col-form-label">Minimum Bet</Label>
                </Col>
                <Col xs={6} sm={8} md={8} lg={6}>
                  <p className="text-muted fw-medium col-form-label">
                    {Number(get(props, "data.minimum_bet", "")).toLocaleString(
                      "en-GB"
                    )}
                  </p>
                </Col>
              </div>

              <div className="row mb-4">
                <Col xs={6} sm={4} md={4} lg={6}>
                  <Label className="col-form-label">Maximum Bet</Label>
                </Col>
                <Col xs={6} sm={8} md={8} lg={6}>
                  <p className="text-muted fw-medium col-form-label">
                    {Number(get(props, "data.maximum_bet", "")).toLocaleString(
                      "en-GB"
                    )}
                  </p>
                </Col>
              </div>
              <div className="row mb-4">
                <Col xs={6} sm={4} md={4} lg={6}>
                  <Label className="col-form-label">Minimum Withdrawal</Label>
                </Col>
                <Col xs={6} sm={8} md={6} lg={6}>
                  <p className="text-muted fw-medium col-form-label">
                    {Number(
                      get(props, "data.minimum_withdrawal", "")
                    ).toLocaleString("en-GB")}
                  </p>
                </Col>
              </div>
              <div className="row mb-4">
                <Col xs={6} sm={4} md={4} lg={6}>
                  <Label className="col-form-label">
                    Maximum Withdrawal/24hrs
                  </Label>
                </Col>
                <Col xs={6} sm={8} md={6} lg={6}>
                  <p className="text-muted fw-medium col-form-label">
                    {Number(
                      get(props, "data.maximum_withdrawal_per_day", "")
                    ).toLocaleString("en-GB")}
                  </p>
                </Col>
              </div>
              <div className="row mb-4">
                <Col xs={6} sm={4} md={4} lg={6}>
                  <Label className="col-form-label">Auto Released Limit</Label>
                </Col>
                <Col xs={6} sm={8} md={6} lg={6}>
                  <p className="text-muted fw-medium col-form-label">
                    {Number(
                      get(props, "data.auto_released_limit", "")
                    ).toLocaleString("en-GB")}
                  </p>
                </Col>
              </div>
              <div className="row mb-4">
                <Col xs={6} sm={4} md={4} lg={6}>
                  <Label className="col-form-label">Maximum Payout</Label>
                </Col>
                <Col xs={6} sm={8} md={6} lg={6}>
                  <p className="text-muted fw-medium col-form-label">
                    {Number(
                      get(props, "data.maximum_payout", "")
                    ).toLocaleString("en-GB")}
                  </p>
                </Col>
              </div>
              <div className="row mb-4">
                <Col xs={6} sm={4} md={4} lg={6}>
                  <Label className="col-form-label">Maximum Bonus Payout</Label>
                </Col>
                <Col xs={6} sm={8} md={6} lg={6}>
                  <p className="text-muted fw-medium col-form-label">
                    {Number(
                      get(props, "data.maximum_bonus_payout", "")
                    ).toLocaleString("en-GB")}
                  </p>
                </Col>
              </div>
              <div className="row mb-4">
                <Col xs={6} sm={4} md={4} lg={6}>
                  <Label className="col-form-label">Bonus Minimum Odds</Label>
                </Col>
                <Col xs={6} sm={8} md={6} lg={6}>
                  <p className="text-muted fw-medium col-form-label">
                    {get(props, "data.minimum_odds", "")}
                  </p>
                </Col>
              </div>
              <div className="row mb-4">
                <Col xs={6} sm={4} md={4} lg={6}>
                  <Label className="col-form-label">
                    Bonus Minimum Matches
                  </Label>
                </Col>
                <Col xs={6} sm={8} md={6} lg={6}>
                  <p className="text-muted fw-medium col-form-label">
                    {Number(
                      get(props, "data.minimum_matches", "")
                    ).toLocaleString("en-GB")}
                  </p>
                </Col>
              </div>
              <div className="row mb-4">
                <Col xs={6} sm={4} md={4} lg={6}>
                  <Label className="col-form-label">
                    Freebet Minimum Odds
                  </Label>
                </Col>
                <Col xs={6} sm={8} md={6} lg={6}>
                  <p className="text-muted fw-medium col-form-label">
                    {Number(
                      get(props, "data.free_bet_minimum_odds", "")
                    ).toLocaleString("en-GB")}
                  </p>
                </Col>
              </div>
              <div className="row mb-4">
                <Col xs={6} sm={4} md={4} lg={6}>
                  <Label className="col-form-label">
                    Freebet Maximum Odds
                  </Label>
                </Col>
                <Col xs={6} sm={8} md={6} lg={6}>
                  <p className="text-muted fw-medium col-form-label">
                    {Number(
                      get(props, "data.free_bet_maximum_odds", "")
                    ).toLocaleString("en-GB")}
                  </p>
                </Col>
              </div>
              <div className="row mb-4">
                <Col xs={6} sm={4} md={4} lg={6}>
                  <Label className="col-form-label">
                    Freebet Minimum Matches
                  </Label>
                </Col>
                <Col xs={6} sm={8} md={6} lg={6}>
                  <p className="text-muted fw-medium col-form-label">
                    {Number(
                      get(props, "data.free_bet_minimum_matches", "")
                    ).toLocaleString("en-GB")}
                  </p>
                </Col>
              </div>
              <div className="row mb-4">
                <Col xs={6} sm={4} md={4} lg={6}>
                  <Label className="col-form-label">
                    Signup Freebet Amount
                  </Label>
                </Col>
                <Col xs={6} sm={8} md={6} lg={6}>
                  <p className="text-muted fw-medium col-form-label">
                    {Number(
                      get(props, "data.signup_freebet_amount", "")
                    ).toLocaleString("en-GB")}
                  </p>
                </Col>
              </div>
              <div className="row mb-4">
                <Col xs={6} sm={4} md={4} lg={6}>
                  <Label className="col-form-label">1st Deposit Odds</Label>
                </Col>
                <Col xs={6} sm={8} md={6} lg={6}>
                  <p className="text-muted fw-medium col-form-label">
                    {get(props, "data.1st_dep_odd", "")}
                  </p>
                </Col>
              </div>
              <div className="row mb-4">
                <Col xs={6} sm={4} md={4} lg={6}>
                  <Label className="col-form-label">1st Deposit Rollover</Label>
                </Col>
                <Col xs={6} sm={8} md={6} lg={6}>
                  <p className="text-muted fw-medium col-form-label">
                    {get(props, "data.1st_dep_bonus", "")}
                  </p>
                </Col>
              </div>
              <div className="row mb-4">
                <Col xs={6} sm={4} md={4} lg={6}>
                  <Label className="col-form-label">Signup Validity</Label>
                </Col>
                <Col xs={6} sm={8} md={6} lg={6}>
                  <p className="text-muted fw-medium col-form-label">
                    {get(props, "data.signup_freebet_bonus_age", "")}
                  </p>
                </Col>
              </div>
              <div className="row mb-4">
                <Col xs={6} sm={4} md={4} lg={6}>
                  <Label className="col-form-label">Signup Rollover</Label>
                </Col>
                <Col xs={6} sm={8} md={6} lg={6}>
                  <p className="text-muted fw-medium col-form-label">
                    {get(props, "data.signup_freebet_rollover_limit", "")}
                  </p>
                </Col>
              </div>
              <div className="row mb-4">
                <Col xs={6} sm={4} md={4} lg={6}>
                  <Label className="col-form-label">Bonus Active</Label>
                </Col>
                <Col xs={6} sm={8} md={6} lg={6}>
                  <Button
                    type="button"
                    color={is_bonus_active == 1 ? "success" : "danger"}
                    className=""
                  >
                    {is_bonus_active == 1 ? "Active" : "DeActive"}
                  </Button>
                </Col>
              </div>

              <div className="row mb-4">
                <Col xs={6} sm={4} md={4} lg={6}>
                  <Label className="col-form-label">Raf Active</Label>
                </Col>
                <Col xs={6} sm={8} md={6} lg={6}>
                  <Button
                    type="button"
                    color={is_raf_active == 1 ? "success" : "danger"}
                    className=""
                  >
                    {is_raf_active == 1 ? "Active" : "DeActive"}
                  </Button>
                </Col>
              </div>


              {hasPermission("update-parameters") && (
                <div className="d-flex flex-wrap gap-2">
                  <Button
                    type="button"
                    color="primary"
                    className=""
                    onClick={handleClick}
                  >
                    Edit
                  </Button>
                </div>
              )}
            </Form>
          </CardBody>
        </Card>
      </Col>
      <Modal centered isOpen={isOpen} toggle={toggle}>
        <ModalHeader tag="h4" toggle={toggle}>
          {"Update Betting Limit"}
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={handleSubmit}>
            <div className="mb-3">
              <Label htmlFor="minimum_bet-Input">Minimum Bet</Label>
              <Input
                type="text"
                className="form-control"
                id="minimum_bet-Input"
                name={"minimumBet"}
                value={minimum_bet}
                required
                onChange={e => {
                  setMinimumBet(e.target.value)
                }}
              />
            </div>

            <div className="mb-3">
              <Label htmlFor="maximum_bet-Input">Maximum Bet</Label>
              <Input
                type="text"
                className="form-control"
                id="maximum_bet-Input"
                name={"maximumBet"}
                value={maximum_bet}
                required
                onChange={e => {
                  setMaximumBet(e.target.value)
                }}
              />
            </div>

            <div className="mb-3">
              <Label htmlFor="minimum_withdrawal_Input">
                Minimum Withdrawal
              </Label>
              <Input
                type="text"
                className="form-control"
                id="minimum_withdrawal_Input"
                name={"MinimumWithdrawl"}
                value={minimum_withdrawal}
                required
                onChange={e => {
                  setMinimumWithdrawl(e.target.value)
                }}
              />
            </div>

            <div className="mb-3">
              <Label htmlFor="maximum_withdrawal_per_day_Input">
                Maximum Withdrawal/24hrs
              </Label>
              <Input
                type="text"
                className="form-control"
                id="maximum_withdrawal_per_day_Input"
                name={"maximumWithdrawl"}
                value={maximum_withdrawal_per_day}
                required
                onChange={e => {
                  setMaximumWithdrawlPerDay(e.target.value)
                }}
              />
            </div>

            <div className="mb-3">
              <Label htmlFor="auto_released_limit_Input">
                Auto Released Limit
              </Label>
              <Input
                type="text"
                className="form-control"
                id="auto_released_limit_Input"
                name={"auto_released_limit"}
                value={auto_released_limit}
                required
                onChange={e => {
                  setAutoReleasedLimit(e.target.value)
                }}
              />
            </div>

            <div className="mb-3">
              <Label htmlFor="maximum_payout_Input">Maximum Payout</Label>
              <Input
                type="text"
                className="form-control"
                id="maximum_payout_Input"
                name={"Maximum Payout"}
                value={maximum_payout}
                required
                onChange={e => {
                  setMaximumPayout(e.target.value)
                }}
              />
            </div>
            <div className="mb-3">
              <Label htmlFor="maximum_bonus_payout_Input">
                Maximum Bonus Payout
              </Label>
              <Input
                type="text"
                className="form-control"
                id="maximum_bonus_payout_Input"
                name={"Maximum Bonus Payout"}
                value={maximum_bonus_payout}
                required
                onChange={e => {
                  setMaximumBonusPayout(e.target.value)
                }}
              />
            </div>

            <div className="mb-3">
              <Label htmlFor="minimum_odds_Input">Minimum Odds</Label>
              <Input
                type="number"
                min="0"
                step={"0.1"}
                className="form-control"
                id="minimum_odds_Input"
                name={"Minimum Odds"}
                value={minimum_odds}
                required
                onChange={e => {
                  setMinimumOdds(e.target.value)
                }}
              />
            </div>

            <div className="mb-3">
              <Label htmlFor="minimum_matches_Input">Freebet Minimum Odds</Label>
              <Input
                type="number"
                min="1"
                step={"1"}
                className="form-control"
                id="freebet_minimum_odds_Input"
                name={"FreeBet Minimum Odds"}
                value={freebet_minimum_odds}
                required
                onChange={e => {
                  set_freebet_minimum_odds(e.target.value)
                }}
              />
            </div>
            <div className="mb-3">
              <Label htmlFor="minimum_matches_Input">Freebet Maximum Odds</Label>
              <Input
                type="number"
                min="0"
                step={"0.01"}
                className="form-control"
                id="freebet_maximum_odds_Input"
                name={"Freebet Maximum Odds"}
                value={freebet_maximum_odds}
                required
                onChange={e => {
                  set_freebet_maximum_odds(e.target.value)
                }}
              />
            </div>
            <div className="mb-3">
              <Label htmlFor="minimum_matches_Input">FreeBet Minimum Matches</Label>
              <Input
                type="number"
                min="1"
                // step={"1"}
                className="form-control"
                id="freebet_minimum_matches_Input"
                name={"Freebet Minimum Matches"}
                value={freebet_minimum_matches}
                required
                onChange={e => {
                  set_freebet_minimum_matches(e.target.value)
                }}
              />
            </div>

            <div className="mb-3">
              <Label htmlFor="minimum_matches_Input">Minimum Matches</Label>
              <Input
                type="number"
                min="1"
                step={"1"}
                className="form-control"
                id="minimum_matches_Input"
                name={"Minimum Matches"}
                value={minimum_matches}
                required
                onChange={e => {
                  setMinimumMatches(e.target.value)
                }}
              />
            </div>
            <div className="mb-3">
              <Label htmlFor="signup_freebet_amount_Input">
                Signup Freebet Amount
              </Label>
              <Input
                type="number"
                min="0"
                step={"1"}
                className="form-control"
                id="signup_freebet_amount_Input"
                name={"Signup Freebet Amount"}
                value={signup_freebet_amount}
                required
                onChange={e => {
                  setSignupFreebetAmount(e.target.value)
                }}
              />
            </div>
            <div className="mb-3">
              <Label htmlFor="minimum_odds_Input">1st Deposit Odds</Label>
              <Input
                type="number"
                min="0"
                className="form-control"
                id="minimum_odds_Input"
                name={"deposit Odds"}
                value={firstDepositOdds}
                required
                onChange={e => {
                  setfirstDepositOdds(e.target.value)
                }}
              />
            </div>
            <div className="mb-3">
              <Label htmlFor="minimum_odds_Input">1st Deposit Rollover</Label>
              <Input
                type="number"
                min="1"
                className="form-control"
                id="minimum_bonus_Input"
                name={"deposit Bonus"}
                value={firstDepositBonus}
                required
                onChange={e => {
                  setfirstDepositBonus(e.target.value)
                }}
              />
            </div>
            <div className="mb-3">
              <Label htmlFor="minimum_odds_Input">Signup Validity</Label>
              <Input
                type="number"
                min="1"
                className="form-control"
                id="minimum_bonus_Input"
                name={"deposit Bonus"}
                value={signupValidity ?? 0}
                required
                onChange={e => {
                  setSignupValidity(e.target.value)
                }}
              />
            </div>
            <div className="mb-3">
              <Label htmlFor="minimum_odds_Input">Signup Rollover</Label>
              <Input
                type="number"
                min="1"
                className="form-control"
                id="minimum_bonus_Input"
                name={"deposit Bonus"}
                value={signupRollover ?? 0}
                required
                onChange={e => {
                  setSignupRollover(e.target.value)
                }}
              />
            </div>
            <div className="mb-3">
              <Label htmlFor="is_bonus_active_Input">Bonus Active</Label>
              <div className="form-check form-switch form-switch-md mb-3">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="is_bonus_active_Input"
                  checked={is_bonus_active == 1 ? true : false}
                  onChange={e => {
                    setIsBonusActive(e.target.checked ? 1 : 0)
                  }}
                />
              </div>
            </div>
            <div className="mb-3">
              <Label htmlFor="is_bonus_active_Input">Raf Active</Label>
              <div className="form-check form-switch form-switch-md mb-3">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="is_raf_active_Input"
                  checked={is_raf_active == 1 ? true : false}
                  onChange={e => {
                    setIsRafActive(e.target.checked ? 1 : 0)
                  }}
                />
              </div>
            </div>

            <div className="text-end">
              <Button type="submit" className="btn btn-success w-md">
                Save
              </Button>
            </div>
          </Form>
        </ModalBody>
      </Modal>
    </React.Fragment>
  )
}
